(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  const navItems = document.querySelectorAll('.header__nav-item');
  let isMenuOpen = false;
  const searchToggle = document.getElementById('search-toggle');
  const searchDropdown = document.querySelector('.header__search-dropdown');
  const searchClose = document.querySelector('.header__search-close');

  if (searchClose) {
    searchClose.addEventListener('click', () => {
      searchDropdown.classList.remove('is-active');
    });
  }

  if (searchToggle && searchDropdown) {
    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      searchDropdown.classList.toggle('is-active');
      if (searchDropdown.classList.contains('is-active')) {
        searchDropdown.querySelector('input').focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!searchToggle.contains(e.target) && !searchDropdown.contains(e.target)) {
        searchDropdown.classList.remove('is-active');
      }
    });
  }

  // Toggle mobile menu
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      isMenuOpen = !isMenuOpen;
      nav.classList.toggle('header__nav--open');
      menuToggle.classList.toggle('is-open');
    });
  }

  // Handle dropdown toggles on mobile
  navItems.forEach(item => {
    const link = item.querySelector('.header__nav-link--has-dropdown');
    if (link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 989) {
          e.preventDefault();
          // Close other dropdowns
          navItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('header__nav-item--open');
            }
          });
          item.classList.toggle('header__nav-item--open');
        }
      });
    }
  });

  // Close menu when clicking outside
  document.addEventListener('click', function(event) {
    if (isMenuOpen && !nav.contains(event.target) && !menuToggle.contains(event.target)) {
      nav.classList.remove('header__nav--open');
      menuToggle.classList.remove('is-open');
      isMenuOpen = false;
      
      // Close all dropdowns
      navItems.forEach(item => {
        item.classList.remove('header__nav-item--open');
      });
    }
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 989) {
        nav.classList.remove('header__nav--open');
        menuToggle.classList.remove('is-open');
        isMenuOpen = false;
        
        // Close all dropdowns
        navItems.forEach(item => {
          item.classList.remove('header__nav-item--open');
        });
      }
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();
})();
